(function (angular, autosize) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyTextareaAutosize", [
    "$timeout",
    function ($timeout) {
      return {
        restrict: "A",
        scope: false,
        link: function (scope, elem, attrs) {
          function getNgModelExpression() {
            return elem.attr("ng-model") || elem.attr("data-ng-model");
          }

          autosize(elem);

          scope.$watch(getNgModelExpression(), function () {
            autosize.update(elem);
          });

          if (attrs.tyTextareaAutosizeWatch) {
            scope.$watch(attrs.tyTextareaAutosizeWatch, function () {
              $timeout(function () {
                autosize.update(elem);
              });
            });
          }
        },
      };
    },
  ]);
})(window.angular, window.autosize);
